import { MarketplaceBillingCycleValues, MarketplacePricingTierPolicyValues } from '@atlassian/mpac-types/dist/GraphQLGateway.gql.types';
import invariant from 'invariant';
import React from 'react';
import { PricingTierAmount as Amount, PricingTierList as List, PricingTierListItem as Item, PricingTierListItemContent as Content, PricingTierListItemHeader as Header, PricingTierRecurrence as Recurrence } from "../PricingTiers.styles";
import { getAmountText } from "./PerUserPricingTiers.utils";
export const PerUserPricingTierUnit = ({
  item
}) => {
  const {
    floor,
    ceiling
  } = item;

  if (floor < 2) {
    // floor is 0 or 1
    invariant(typeof ceiling === 'number', "Ceiling cannot be unspecified when floor (".concat(floor, ") less than 2"));
    return "Up to ".concat(ceiling, " users");
  }

  if (ceiling) {
    return "".concat(floor, "\u2013").concat(ceiling, " users");
  }

  return "".concat(floor, "+ users");
};
export const PerUserPricingTierRecurrence = ({
  item,
  billingCycle
}) => {
  if (item.policy === MarketplacePricingTierPolicyValues.Block) {
    const cycleLabel = billingCycle === MarketplaceBillingCycleValues.Annual ? 'yearly' : 'monthly';
    return "".concat(cycleLabel, " flat fee");
  }

  const cycleLabel = billingCycle === MarketplaceBillingCycleValues.Annual ? 'year' : 'month';
  return "per user/".concat(cycleLabel);
};
export const PerUserPricingTiersGrid = props => {
  const {
    items,
    currency,
    billingCycle
  } = props;
  return /*#__PURE__*/React.createElement(List, null, items.map((item, index) => /*#__PURE__*/React.createElement(Item, {
    key: index
  }, /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(PerUserPricingTierUnit, {
    item: item
  })), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Amount, null, getAmountText(item.amount, currency)), /*#__PURE__*/React.createElement(Recurrence, null, /*#__PURE__*/React.createElement(PerUserPricingTierRecurrence, {
    billingCycle: billingCycle,
    item: item
  }))))));
};